var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import { Body, Link } from '@lendi-ui/typography';
import styled from 'styled-components';
import getColour from '@lendi-ui/commons/colours';
var LinkWrapper = styled(Link)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  color: ", ";\n  text-decoration: none;\n  pointer-events: ", ";\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: 24px;\n"], ["\n  color: ", ";\n  text-decoration: none;\n  pointer-events: ", ";\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: 24px;\n"])), function (_) { return getColour('interaction', 'main'); }, function (props) { return (props.wrongNumberClicked ? 'none' : 'auto'); });
export var ResendAction = function (_a) {
    var _b = _a.countdown, countdown = _b === void 0 ? 20 : _b, handleClick = _a.handleClick, wrongNumberClicked = _a.wrongNumberClicked, props = __rest(_a, ["countdown", "handleClick", "wrongNumberClicked"]);
    var _c = React.useState(countdown), timeLeft = _c[0], setTimeLeft = _c[1];
    var _d = React.useState(true), isCounting = _d[0], setIsCounting = _d[1];
    React.useEffect(function () {
        var intervalId;
        if (isCounting && timeLeft > 0) {
            intervalId = setInterval(function () {
                setTimeLeft(function (prevTimeLeft) { return prevTimeLeft - 1; });
            }, 1000);
        }
        return function () {
            clearInterval(intervalId);
        };
    }, [isCounting, timeLeft]);
    React.useEffect(function () {
        setIsCounting(!wrongNumberClicked);
    }, [wrongNumberClicked]);
    return (React.createElement(Body, __assign({ align: "center" }, props), timeLeft > 0 ? ("Didn\u2019t receive a one-time passcode? You can request a new one in ".concat(timeLeft, "s")) : (React.createElement(LinkWrapper, { wrongNumberClicked: wrongNumberClicked, onClick: function () {
            handleClick();
            setTimeLeft(countdown);
        } }, "Request a new one-time passcode"))));
};
var templateObject_1;
//# sourceMappingURL=index.js.map